import useReveal from "../hooks/useReveal";
import CTA from "../components/CTA";
import { Sparkles } from "lucide-react";
import { weddingServices, eventServices } from "../data/mock";

export default function ServicesPage({ kind = "weddings" }) {
  useReveal([kind]);
  const isWedding = kind === "weddings";
  const heading = isWedding
    ? "Luxury Wedding and Anniversary Planning"
    : "Luxury Event Planning";
  const sub = isWedding
    ? "From your first look to the last dance — every heartbeat, considered."
    : "Landmark birthdays, baby showers, and graduations, crafted with care.";
  const items = isWedding ? weddingServices : eventServices;
  const hero = items[0];

  return (
    <div className="pt-32">
      <section className="mx-auto max-w-[1400px] px-6 md:px-10 py-16">
        <div className="kicker reveal">{isWedding ? "Weddings" : "Events"}</div>
        <h1 className="font-display text-4xl md:text-7xl leading-[1.02] mt-6 max-w-4xl reveal">
          {heading.split(" ").map((w, i) =>
            i === 1 ? (
              <span key={`${w}-${i}`} className="italic"> {w} </span>
            ) : (
              <span key={`${w}-${i}`}> {w} </span>
            )
          )}
        </h1>
        <p className="mt-8 max-w-xl text-[hsl(var(--ink-soft))] leading-relaxed reveal">{sub}</p>
      </section>

      <section className="reveal img-zoom">
        <img
          src={hero.image}
          alt={heading}
          className="w-full h-[70vh] object-cover"
          style={hero.objectPosition ? { objectPosition: hero.objectPosition } : undefined}
        />
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-36">
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-24">
          {items.map((s, i) => (
            <div key={s.id} className={`reveal ${i % 2 ? "md:mt-24" : ""}`}>
              <div className="img-zoom">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-[440px] object-cover"
                  style={s.objectPosition ? { objectPosition: s.objectPosition } : undefined}
                />
              </div>
              <div className="kicker mt-6">{s.kicker}</div>
              <h3 className="font-display text-2xl md:text-3xl mt-3 leading-tight">{s.title}</h3>
              <p className="mt-4 text-[hsl(var(--ink-soft))] leading-relaxed max-w-md">{s.excerpt}</p>
              <div className="mt-6">
                {s.cta?.action === "mood-board" ? (
                  <button
                    type="button"
                    onClick={() => window.dispatchEvent(new Event("sws:open-mood-board"))}
                    data-testid={`service-${s.id}-cta`}
                    className="inline-flex items-center gap-2 border border-[hsl(var(--ink))] text-[hsl(var(--ink))] px-6 py-3 text-[11px] tracking-[0.3em] uppercase hover:bg-[hsl(var(--accent))] hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--bg))] transition-colors duration-500"
                  >
                    <Sparkles size={14} /> {s.cta.label}
                  </button>
                ) : (
                  <CTA to="/contact" label="Enquire" />
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[hsl(var(--bg-alt))] py-24">
        <div className="mx-auto max-w-[1200px] px-6 text-center">
          <div className="kicker">Investment</div>
          <h3 className="font-display text-3xl md:text-5xl mt-6 leading-tight reveal">
            Our full-service planning begins at <span className="italic">10&ndash;15%</span> of your total budget, with a considered minimum fee.
          </h3>
          <p className="mt-8 max-w-2xl mx-auto text-[hsl(var(--ink-soft))] leading-relaxed reveal">
            Every proposal is bespoke. After a complimentary consultation, we craft a scope that reflects
            the size, style and location of your celebration — with complete transparency on cost.
          </p>
          <div className="mt-10"><CTA to="/contact" label="Book a consultation" /></div>
        </div>
      </section>
    </div>
  );
}
